// Necht je dana primka `line` body A a B
// Necht je bod `point` dan bodem C
// vraci cislo od nuly do jedne, nula je nejblizsi bod
export const pointDistanceFromLinePenalty = (line, point) => {
    const [a, b] = line;
    const c = point;
    // shift A to point [0,0]
    const bx = b[0] - a[0];
    const by = b[1] - a[1];
    const cx = c[0] - a[0];
    const cy = c[1] - a[1];
    if (by === 0 || cy === 0) {
        return Math.abs(by / bx - cy / cx);
    }
    else {
        return Math.abs(bx / by - cx / cy);
    }
};
export const getIntersectionSegmentIndexByDistance = (multiLineString, intersectionCoord) => {
    let distanceSquare = Infinity;
    let selectedSegment = {
        lineStringSegmentIndex: null,
        lineStringIndex: null,
    };
    multiLineString.forEach((lineString, lineStringIndex) => {
        const lineStringLength = lineString.length;
        for (let lineStringSegmentIndex = 0; lineStringSegmentIndex < lineStringLength - 1; lineStringSegmentIndex++) {
            const segmentStartPoint = lineString[lineStringSegmentIndex];
            const segmentEndPoint = lineString[lineStringSegmentIndex + 1];
            const currentDistanceSquare = pointDistanceFromLinePenalty([segmentStartPoint, segmentEndPoint], intersectionCoord);
            if (currentDistanceSquare < distanceSquare) {
                distanceSquare = currentDistanceSquare;
                selectedSegment = { lineStringSegmentIndex, lineStringIndex };
            }
        }
    });
    return selectedSegment;
};
//# sourceMappingURL=getIntersectionSegmentIndexByDistance.js.map